import {Navigate, Outlet, useLocation} from "react-router-dom";
import {LoadingOverlay} from "@mantine/core";
import {useExperimentalMode} from "../chat/useExperimentalMode";
import ChatView from "../chat/sliceChatComponents/ChatView";
import {DashboardLayout} from "./DashboardLayout";

export function DashboardGuard() {
    const {isExperimental, isLoading} = useExperimentalMode();
    const location = useLocation();
    const isIndex = location.pathname === "/";

    if (isLoading) return <LoadingOverlay visible />;

    if (!isExperimental) {
        if (isIndex) return <ChatView />;
        return <Navigate to="/" replace />;
    }

    return <DashboardLayout />;
}
